/**
 * Language: Italian.
 */
export default {
    "messages": {
        "choose_thematic": "Scegli Tematica",
        "sessionReset": "La sessione si reimposterà automaticamente tra",
        "minute": "minuto",
        "resetMap": "Reimposta Mappa",
        "selectLanguage": "Seleziona una Lingua",
        "seconds": "secondi",
        "cta": {
            "switch_standard_view": "Passa alla visualizzazione standard"
        },
        "minutes": "minuti",
        "multilevelwarning": "Questo percorso è su due livelli e passa anche per il Quick Link a livello 1",
    },
    "thematics": {
        "outdoor": "Outdoor",
        "textile": "Tessile",
        "wallpaper": "Wallpaper",
        "kitchen": "Cucina Contract",
        "bathroom": "Progetto Bagno",
    },
    "thematicDescription": {
        "outdoor": "Design, durabilità e comfort: evoluzione continua per arredare giardini, terrazzi e spazi di piccole dimensioni.",
        "textile": "Percorsi tessili che intrecciano tecnologie più avanzate e inconfondibile segno artigianale.",
        "wallpaper": "Soluzioni e ricerche tra materiali, pattern e colori che uniscono tecnica ed estetica.",
        "kitchen": "Progetti, arredi su misura e soluzioni per hotel, residence, uffici e retail.",
        "bathroom": "Arredi ad alto tasso di innovazione: la sostenibilità idrica secondo Salotto NY.",
    },
    "errors": {
        "loadingLibrary": "Impossibile caricare lo script {library}",
        "geolocationFailed": "Geolocalizzazione dell'utente fallita",
        "apiErrors": {
            "401": "Non autorizzato",
            "403": "Vietato",
            "429": "Troppe richieste",
            "500": "Errore interno del server",
            "other": "Si è verificato un errore imprevisto del server"
        }
    }
};
